'use client';

import Rive from '@rive-app/react-canvas'

export { Rive as RiveAnim }